const routes = [
    {
        path: "/room/reservation/system",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'housingbed_index'
        }
    }
];

export default routes;
